import { KeyboardArrowUp } from "@mui/icons-material"
import { Menu, MenuItem, Stack } from "@mui/material"
import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setSelectedPlugin } from "store/userSettingsSlice";
import ChangeBiz from "./ChangeBiz";
import NullCheck from "components/NullCheck";
import { MANAGER } from "config/roles";

const PluginSelect = ({ pluginLogos, logo, isMobile, biz, user }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [open, setOpen] = useState(null);
    const [openChangeBiz, setOpenChangeBiz] = useState({ open: false, list: [], pluginSysName: null });

    const handleClickPluginMenu = (event) => {
        setOpen(event.currentTarget);
    };

    const handleClosePluginMenu = () => {
        setOpen(null);
    };

    const onSelectedPlugin = (pluginSysName) => {
        let bizData = MANAGER.includes(user?.userRole) ? biz : user?.business?.find(b => b?.id === biz?.id)
        const hasPlugin = bizData?.plugins?.some(i => i === pluginSysName || i?.sysName === pluginSysName)

        if (hasPlugin) {
            dispatch(setSelectedPlugin(pluginSysName));
            navigate('/Dashboard');
        }

        else {
            const newBizList = user?.business?.filter(b => b?.plugins?.some((pl) => pl === pluginSysName))
            setOpenChangeBiz({ open: true, list: newBizList, pluginSysName: pluginSysName })
        }

        handleClosePluginMenu();
    }

    return (
        <div>
            <Stack
                direction={{ xs: 'row-reverse', md: 'row' }}
                alignItems='center'
                sx={{ cursor: pluginLogos?.length > 0 ? "pointer" : "auto" }}
                spacing={{ xs: 0, md: 1 }}
                onClick={(e) => pluginLogos?.length > 0 ? handleClickPluginMenu(e) : null}
            >
                <img src={logo} style={{ fill: '000' }} width={isMobile ? 150 : 180} />

                <NullCheck valueForCheck={pluginLogos?.length > 0}>
                    <KeyboardArrowUp
                        sx={{
                            transform: open ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform 0.3s ease",
                        }}
                    />
                </NullCheck>
            </Stack>

            <NullCheck valueForCheck={pluginLogos?.length > 0}>
                <Menu
                    MenuListProps={{ "aria-labelledby": "long-button" }}
                    anchorEl={open}
                    open={open ? true : false}
                    onClose={handleClosePluginMenu}
                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                    transformOrigin={{ vertical: "top", horizontal: "left" }}
                >
                    {pluginLogos?.map((pl, idx) => {
                        return (
                            <MenuItem
                                sx={{
                                    backgroundColor: "transparent !important",
                                    "&:hover": { backgroundColor: "transparent !important" },
                                    "&.Mui-selected": {
                                        backgroundColor: "transparent !important",
                                        "&:hover": { backgroundColor: "transparent !important" },
                                    },
                                }}
                                key={idx}
                                onClick={() => onSelectedPlugin(pl.sysName)}
                            >
                                <img src={pl?.logo} style={{ fill: '000' }} width={isMobile ? 150 : 160} />
                            </MenuItem>
                        )
                    })}

                </Menu>
            </NullCheck>

            <NullCheck valueForCheck={openChangeBiz.open}>
                <ChangeBiz
                    data={openChangeBiz}
                    setData={setOpenChangeBiz}
                />
            </NullCheck>
        </div>
    )
}

export default PluginSelect